export default {
  pageTitle: {
    default: 'Home'
  },
  backBtnIconOptions: {
    type: 'button',
    name: 'back-btn',
    icon: true,
    iconType: 'back',
    navigation: true,
    tooltip: 'Go back'
  },
  formButtons: [
    {
      type: 'submit',
      name: 'save-btn',
      text: 'Save',
      icon: true,
      iconType: 'save',
      primary: true,
      disabled: false,
      tooltip: 'Save record'
    },
    {
      type: 'reset',
      name: 'reset-btn',
      text: 'Reset',
      icon: true,
      iconType: 'reset',
      primary: false,
      disabled: false,
      tooltip: 'Reset fields'
    },
    {
      type: 'button',
      name: 'cancel-btn',
      text: 'Cancel',
      icon: true,
      iconType: 'cancel',
      primary: false,
      disabled: false,
      tooltip: 'Cancel'
    }
  ],
  refreshBtnIconOptions: {
    type: 'button',
    name: 'refresh-btn',
    icon: true,
    iconType: 'refresh',
    tooltip: 'Refresh'
  },
  exitBtnIconConfigOptions: {
    type: 'button',
    name: 'exit-btn',
    primary: true,
    icon: true,
    iconType: 'close',
    tooltip: 'Exit'
  },
  formBtnIconOptions: [
    { type: 'submit', name: 'save-btn', primary: true, icon: true, iconType: 'save', tooltip: 'Save record' },
    { type: 'reset', name: 'reset-btn', icon: true, iconType: 'reset', tooltip: 'Reset fields' },
    { type: 'button', name: 'cancel-btn', icon: true, iconType: 'cancel', tooltip: 'Cancel action' }
  ],
  navOptions: {
    default: {
      name: 'home-navigation',
      items: [
        { name: 'Home', route: { name: 'Home' } },
        { name: 'Games', route: { name: 'GameList' } },
        { name: 'Categories', route: { name: 'CategoryList' } },
        { name: 'Brands', route: { name: 'BrandList' } },
        { name: 'Territories', route: { name: 'TerritoryList' } },
        { name: 'Languages', route: { name: 'LanguageList' } },
        { name: 'Game Order', route: { name: 'GameOrderList' } }
      ]
    }
  }
}
